import firebase from 'firebase/app';
import { nanoid } from 'nanoid';
import imageCompression from 'browser-image-compression';
import { v4 as uuid } from 'uuid';
import axios from 'axios';

import 'firebase/firestore';
import 'firebase/storage';
import { Challenge, CustomFile } from '../types/types';

const CHALLENGEDURATIONDAYS = 7;
const IDLENGTH = 10;

const firebaseConfig = {
  apiKey: 'AIzaSyB1jyPVzB1NOXwAX5sNRh6xo55ofnf03zY',
  authDomain: 'squiblite.firebaseapp.com',
  projectId: 'squiblite',
  storageBucket: 'squiblite.appspot.com',
  messagingSenderId: '733881264532',
  appId: '1:733881264532:web:368bc9fa83c39f88f70781',
};

firebase.initializeApp(firebaseConfig);

export type timestamp = firebase.firestore.Timestamp;
export const Timestamp = firebase.firestore.Timestamp;
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export type FieldValue = firebase.firestore.FieldValue;
export const counterIncrement = firebase.firestore.FieldValue.increment;

const compressPicture = async (picture: File): Promise<File> => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
  };
  return await imageCompression(picture, options);
};

export const uploadPicture = async (picture: CustomFile): Promise<string | null> => {
  const { selectedFile } = picture;
  try {
    const compressedFile = await compressPicture(selectedFile);
    const newId = uuid();

    return new Promise<string | null>((resolve, reject) => {
      const filePath = `/uploads/${newId}.jpeg`;
      const uploadTask = storage.ref().child(filePath).put(compressedFile);

      uploadTask.on(
        'state_changed',
        null,
        () => {
          reject(null);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            resolve(downloadURL);
          });
        },
      );
    });
  } catch {
    return null;
  }
};

export const getChallenge = async (id: string, func: (c: Challenge) => void): Promise<boolean> => {
  const docRef = firestore.collection('challenges').doc(id);

  return docRef.get().then(doc => {
    if (doc.exists) {
      const challengeData = doc.data() as Challenge;
      // if (challengeData.dateExpire.toDate() < new Date()) return false;
      func(challengeData);
      return true;
    }
    return false;
  });
};

export const getQrCode = async (id: string): Promise<string | undefined> => {
  const docRef = firestore.collection('qrcodes').doc(id);
  return docRef.get().then(doc => {
    if (doc.exists) {
      const data = doc.data() as { mappedValue: string };
      return data.mappedValue;
    }
    return undefined;
  });
};

export const uploadChallenge = async (imgL: string, imgR: string, title: string, question: string, token: string): Promise<string> => {
  const newId = nanoid(IDLENGTH);
  const date = new Date();
  date.setDate(date.getDate() + CHALLENGEDURATIONDAYS);

  const challenge = {
    imageLeft: imgL,
    imageRight: imgR,
    title: title,
    question: question,
    dateExpire: date,
  };

  const url = '../.netlify/functions/createChallenge';
  const res = await axios({
    method: 'POST',
    url: url,
    data: {
      challenge: challenge,
      id: newId,
      token: token,
    },
  });

  return res.status == 200 ? newId : '';
};
